/**
*
* RedInsights
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import Wrapper from 'components/Templates/dynamics/Wrapper';

import defaultTextValues from './defaultTextValues';

class RedInsights extends React.Component {


  render() {

    const {
      commonData,
      openEditor,
      commonProps,
      defaultValues
    } = this.props;


    const {
      speakerLength,
      companiesLength,
      daysLength,
      attendeesLength
    } = defaultValues;

    const insightsDefaultValues = {
      insightNumberOne: {[commonProps.language]: `${speakerLength ? speakerLength : 0 }`},
      insightNumberTwo: {[commonProps.language]: `${companiesLength ? companiesLength : 0 }`},
      insightNumberThree: {[commonProps.language]: `${daysLength ? daysLength : 0 }`},
      insightNumberFour: {[commonProps.language]: `${attendeesLength ? attendeesLength : 0 }`}
    }

    return (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'wrapperWithMargin'}
          editorData={
            {
              editorType: 'wrapperWithMargin',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'sectionTitle'}
            type={'text'}
            defaultValues={defaultTextValues}
            editorData={
              {
                editorType: 'sectionTitle',
                ...commonData
              }
            }
          />
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'insightsWrapper'}
            editorData={
              {
                editorType: 'insightsWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'insight'}
              editorData={
                {
                  editorType: 'insight',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'insightNumberOne'}
                defaultValues={insightsDefaultValues}
                type={'text'}
                editorData={
                  {
                    editorType: 'insightNumberOne',
                    ...commonData
                  }
                }
              />
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'insightSubtitleOne'}
                type={'text'}
                defaultValues={defaultTextValues}
                editorData={
                  {
                    editorType: 'insightSubtitleOne',
                    ...commonData
                  }
                }
              />
            </Wrapper>
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'insight'}
              editorData={
                {
                  editorType: 'insight',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'insightNumberTwo'}
                defaultValues={insightsDefaultValues}
                type={'text'}
                editorData={
                  {
                    editorType: 'insightNumberTwo',
                    ...commonData
                  }
                }
              />
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'insightSubtitleTwo'}
                type={'text'}
                defaultValues={defaultTextValues}
                editorData={
                  {
                    editorType: 'insightSubtitleTwo',
                    ...commonData
                  }
                }
              />
            </Wrapper>
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'insight'}
              editorData={
                {
                  editorType: 'insight',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'insightNumberThree'}
                defaultValues={insightsDefaultValues}
                type={'text'}
                editorData={
                  {
                    editorType: 'insightNumberThree',
                    ...commonData
                  }
                }
              />
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'insightSubtitleThree'}
                defaultValues={defaultTextValues}
                type={'text'}
                editorData={
                  {
                    editorType: 'insightSubtitleThree',
                    ...commonData
                  }
                }
              />
            </Wrapper>
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'insight'}
              editorData={
                {
                  editorType: 'insight',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'insightNumberFour'}
                defaultValues={insightsDefaultValues}
                type={'text'}
                editorData={
                  {
                    editorType: 'insightNumberFour',
                    ...commonData
                  }
                }
              />
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'insightSubtitleFour'}
                type={'text'}
                defaultValues={defaultTextValues}
                editorData={
                  {
                    editorType: 'insightSubtitleFour',
                    ...commonData
                  }
                }
              />
            </Wrapper>
          </Wrapper>
        </Wrapper>
      </Wrapper>
    );


  }
}

RedInsights.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  defaultValues: PropTypes.object
};

export default RedInsights;
